<template>
  <div>

     <div v-if="loading">
        <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base-side-bar
          title=""
          :submit-status="submitStatus"
          action="Update"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <label class="form-group has-float-label mb-4">
              <input
                type="text"
                @blur="$v.role.name.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.role.name.$error }"
                v-model="role.name"
              />
              <span>Role</span>
              <div class="invalid-feedback" v-if="!$v.role.name.required">
                Please enter role
              </div>
            </label>

            <div class="form-group">
               <label class="form-label">Please select permissions</label>
              <span v-for="item in permissions" :key="item.id">
              <b-form-checkbox
                v-model="role.permissions"
                :value="item.id"
              >
               {{ item.name }}
              </b-form-checkbox>
              </span>
                <div class="text-danger" v-if="$v.role.permissions.$error">
                Please select permissions
              </div>
            </div>

         </template>
        </form-base-side-bar>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import roleRepo from '@/api/repos/roleRepo'
import { required } from 'vuelidate/lib/validators'
import formBaseSideBar from '@/components/common/FormBaseSideBar'
import permissionRepo from '@/api/repos/permissionRepo'

export default {
  components: {
    formBaseSideBar
  },

  validations: {
    role: {
      name: {
        required
      },
      permissions: {
        required
      }
    }
  },

  mounted () {
    this.getRole()
    this.getPermissions()
  },

  props: ['id'],

  data () {
    return {
      role: {
        name: '',
        permissions: []
      },
      permissions: [],
      loading: false,
      errors: [],
      submitStatus: null,
      imageUploading: false
    }
  },

  methods: {
    async getPermissions () {
      let { data } = await permissionRepo.permissions()
      this.permissions = data.permissions
    },

    async getRole () {
      try {
        this.loading = true;
        let { data } = await roleRepo.get(this.id)
        this.role.name = data.role.name
        this.role.permissions = data.role_permissions
      } catch (error) {
        console.log(error)
      } finally{
        this.loading = false
      }
    },
    async handleSubmit () {
      this.loading = true
      this.submitStatus = 'PENDING'
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
        this.loading = false
      } else {
        try {
          await roleRepo.update(this.id, this.role)
          this.$emit("roleUpdated");
        } catch (error) {
          console.log(error)
          if (error.response.status === 422) {
            this.errors = error.response.data.errors
            console.log(this.errors)
          }
        } finally {
          this.loading = false
          this.submitStatus = null
        }
      }
    }
  }
}
</script>

<style></style>
